import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { useCallback, useRef } from "react";
import { useModal } from "@/hooks";
import classnames from "classnames";
import { ExpirationDateField, TextField } from "@/components/Form/Parts/index";
import CvvModal from "@/components/CvvModal";
import formStyles from "@/styles/Form.module.scss";
import paymentSelectStyles from "@/styles/PaymentSelect.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IconHelp = function IconHelp(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(-412.636 -587.133)",
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "7",
        cy: "7",
        r: "7",
        transform: "translate(412.636 587.133)",
        fill: "#646464"
      }), /*#__PURE__*/_jsx("g", {
        style: {
          isolation: "isolate"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M418.865,596.055a3.488,3.488,0,0,0,.031-.421l-.011-.189a1.959,1.959,0,0,1,.41-1.289,3.017,3.017,0,0,1,.939-.75c.64-.43.88-.749.88-1.2,0-.61-.53-.99-1.389-.99a1.336,1.336,0,0,0-1.429,1.32l-1.48-.18a2.481,2.481,0,0,1,.789-1.5,3.239,3.239,0,0,1,2.209-.7c1.61,0,2.719.819,2.719,2a1.9,1.9,0,0,1-.349,1.179,4.312,4.312,0,0,1-1.23,1.019c-.63.42-.779.66-.779,1.189a5.03,5.03,0,0,0,.029.511Zm1.39.83v1.369h-1.449v-1.369Z",
          fill: "#e6e6e6"
        })
      })]
    })
  }));
};

IconHelp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14"
};
export default function CreditCardInput(_ref) {
  var _errors$cardNumber, _errors$expirationDat, _errors$cvv;

  var register = _ref.register,
      errors = _ref.errors,
      setValue = _ref.setValue,
      visible = _ref.visible;
  if (!visible) return null;

  var _useModal = useModal(),
      showModal = _useModal.showModal;

  var bsDelKey = useRef();
  var handleKeyDown = useCallback(function (e) {
    bsDelKey.current = e.code === "Backspace" || e.code === "Delete";
  });
  var handleInputCardNumber = useCallback(function (e) {
    if (bsDelKey.current) return false;
    var digit = e.target.value.replace(/[^\d]+/g, ""); // ブランド判別

    var chunkMap = function () {
      if (/^(34|37)/.test(digit)) {
        // Amex 4-6-5
        return [[0, 4], [4, 10], [10, 15]];
      } else if (/^(30|36|38|39)/.test(digit)) {
        // Diners 4-6-4
        return [[0, 4], [4, 10], [10, 14]];
      } else {
        // Other 4-4-4-4
        return [[0, 4], [4, 8], [8, 12], [12, 16]];
      }
    }();

    var value = chunkMap.reduce(function (acc, n, i) {
      var _n = _slicedToArray(n, 2),
          start = _n[0],
          end = _n[1];

      var chnkValue = digit.slice(start, end);
      acc = acc + chnkValue;

      if (i !== chunkMap.length - 1 && chnkValue.length === end - start) {
        acc = acc + "-";
      }

      return acc;
    }, "");
    e.target.value = value;
  }, []);
  var handleInputCvv = useCallback(function (e) {
    if (!/^\d{1,16}$/.test(e.target.value)) {
      e.target.value = e.target.value.replace(/[^\d]+/g, "");
    }
  }, []);
  var handleCvvBtnClick = useCallback(function () {
    showModal( /*#__PURE__*/_jsx(CvvModal, {}), {
      closeButton: false,
      outerAreaClose: false,
      style: "dialogue"
    });
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: paymentSelectStyles.addCreditCardSection,
    children: [/*#__PURE__*/_jsx("header", {
      className: paymentSelectStyles.header,
      children: /*#__PURE__*/_jsx("h4", {
        className: paymentSelectStyles.heading,
        children: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u60C5\u5831"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: paymentSelectStyles.creditCardInfoContainer,
      children: [/*#__PURE__*/_jsx("div", {
        className: paymentSelectStyles.creditCardNumberField,
        children: /*#__PURE__*/_jsx(TextField, {
          ref: register,
          name: "cardNumber",
          title: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u756A\u53F7",
          placeholder: "\u534A\u89D2\u6570\u5B57\u3067\u30AB\u30FC\u30C9\u756A\u53F7\u3092\u5165\u529B",
          error: (_errors$cardNumber = errors.cardNumber) === null || _errors$cardNumber === void 0 ? void 0 : _errors$cardNumber.message,
          required: true,
          className: paymentSelectStyles.creditCardTextInput,
          onInput: handleInputCardNumber,
          onKeyDown: handleKeyDown
        })
      }), /*#__PURE__*/_jsx("div", {
        className: paymentSelectStyles.creditCardExpirationDateField,
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(ExpirationDateField, {
            ref: register,
            name: "expirationDate",
            title: "\u6709\u52B9\u671F\u9650",
            error: (_errors$expirationDat = errors.expirationDate) === null || _errors$expirationDat === void 0 ? void 0 : _errors$expirationDat.message,
            setValue: setValue,
            required: true
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: paymentSelectStyles.creditCardCvvField,
        children: [/*#__PURE__*/_jsxs("legend", {
          className: classnames(formStyles.formTitle, _defineProperty({}, formStyles.required, true)),
          children: ["\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9", /*#__PURE__*/_jsx("a", {
            onClick: handleCvvBtnClick,
            className: paymentSelectStyles.iconHelp,
            children: /*#__PURE__*/_jsx(IconHelp, {})
          })]
        }), /*#__PURE__*/_jsx(TextField, {
          ref: register,
          inputMode: "numeric",
          name: "cvv",
          placeholder: "\u534A\u89D2\u6570\u5B57\u3067\u5165\u529B",
          error: (_errors$cvv = errors.cvv) === null || _errors$cvv === void 0 ? void 0 : _errors$cvv.message,
          onInput: handleInputCvv,
          maxLength: "4",
          required: true
        })]
      })]
    })]
  });
}